import validate from "/usr/src/app/content/n3-packages-bd4abdd3-c9b4-414b-a749-71db14b01566/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-bd4abdd3-c9b4-414b-a749-71db14b01566/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}